module.exports = __webpack_public_path__ + "static/img/6.fe55160a.jpg";